module.exports = __webpack_public_path__ + "static/solutions-architect-professional-0584ffcfdc8ee3bdea6b83d5b41a70b8.png";